import React, { useContext, useEffect, useState } from 'react'
import { withRouter } from 'react-router-dom'
import styled from 'styled-components'
import CircularProgress from '@material-ui/core/CircularProgress'
import AddItem from './components/add-item'
import FoodForm from './components/food-form'
import { convertNutritionixData } from './components/util'
import Item from '../inspect/components/tracker/item'
import GenericItem from '../../../../images/genericFood.png'
import {ReactComponent as AddIcon } from '../../../../images/iconAdd.svg'
import { getFavoriteMeals, insertFavoriteMeal, updateFavoriteMeal } from '../../../../api'
import { lookupBrandItem, lookupNaturalItem } from '../../../../nutritionix'
import { AuthContext } from '../../../../auth-context'
import Button from '../../../../components/button'
import Input from '../../../../components/input'
import '../../../../css/add-item.sass'
import { DashboardContext } from '../../dashboard-context'
import {MacrosDisplay} from './components/macros-display'

const MealContainer = styled.div`
  margin: 0 auto;
  max-width: 1000px;
  padding: 64px 32px;
`

const PageTitle = styled.h2`
  margin: 0 auto 30px auto;
  color: #181818;
  font-family: 'DM Sans', sans-serif;
  font-size: 1.25rem;
  font-weight: 600;
`

const ButtonContainer = styled.div`
  display: flex;
  margin-top: 20px;

  @media(max-width: 900px) {
    margin-top: 16px;
  }
`

const AddButton = styled(Button)`
  margin: 0;
  margin-right: 16px;
  min-width: 180px;
`

const MealEdit = (props) => {
  const mealIdStr = props.match.params.id
  const { user } = useContext(AuthContext)
  const { openSnackbar } = useContext(DashboardContext)
  const [proxyUserId, updateProxyUserId] = useState(null)
  const [meals, updateMeals] = useState(null)
  const [name, updateName] = useState(null)
  const [foods, updateFoods] = useState(null)
  const [notes, updateNotes] = useState(null)
  const [nameError, updateNameError] = useState(false)
  const [mealStatus, updateMealStatus] = useState(0)
  const [itemType, updateItemType] = useState('food')
  const [showAddItemModal, updateShowAddItemModal] = useState(false)
  const [showFoodForm, updateShowFoodForm] = useState(false)
  const [foodLoading, updateFoodLoading] = useState(false)
  const [foodItem, updateFoodItem] = useState(null)
  const [foodKind, updateFoodKind] = useState(null)
  const [editingItemIndex, updateEditingItemIndex] = useState(null)
  const [saving, updateSaving] = useState(false)
  const [search, updateSearch] = useState('');

  useEffect(() => {
    if(mealStatus === 0) {
      updateMealStatus(1)
      getFavoriteMeals(user.id).then((res) => {
        updateProxyUserId(res.data.proxy_user_id)
        updateMeals(res.data.meals)
        if (mealIdStr === '0') {
          updateName('')
          updateFoods([])
          updateNotes('')
        } else {
          const mealId = Number(mealIdStr)
          for (let n = 0; n < res.data.meals.length; ++n) {
            if (res.data.meals[n].id === mealId) {
              updateName(res.data.meals[n].name)
              updateFoods(res.data.meals[n].foods)
              updateNotes(res.data.meals[n].notes)
              break
            }
          }
        }
        updateMealStatus(2)
      })
    }
  }, [mealIdStr, mealStatus, user.id])

  const handleAddFood = () => {
    updateShowAddItemModal(true)
  }

  const handleItemAfterQuery = (res) => {
    let newFood = convertNutritionixData(res.data.foods[0])
    newFood.itemType = itemType
    updateFoodItem(newFood)
    updateFoodLoading(false)
  }

  const handleAddItemPress = (item) => {
    updateShowAddItemModal(false)
    updateFoodLoading(true)
    if (item.nix_item_id) {
      updateFoodKind('brand')
      updateShowFoodForm(true)
      lookupBrandItem(proxyUserId, item.nix_item_id).then(handleItemAfterQuery).catch((err) => {
        console.log('lookupBrandItem failed')
        console.log(err)
        updateShowFoodForm(false)
        updateFoodLoading(false)
        updateShowAddItemModal(true)
      })
    } else {
      updateFoodKind('natural')
      updateShowFoodForm(true)
      lookupNaturalItem(proxyUserId, item.food_name).then(handleItemAfterQuery).catch((err) => {
        console.log('lookupNaturalItem failed')
        console.log(err)
        updateShowFoodForm(false)
        updateFoodLoading(false)
        updateShowAddItemModal(true)
      })
    }
  }

  const handleAddCustomPress = () => {
    updateShowAddItemModal(false)
    updateFoodLoading(false)
    updateFoodItem(null)
    updateFoodKind('custom')
    updateShowFoodForm(true)
  }

  const handleEditCurrent = (itemIndex) => {
    const editingItem = new Item(foods[itemIndex])
    updateEditingItemIndex(itemIndex)
    updateFoodLoading(false)
    updateFoodItem(editingItem)
    updateFoodKind('current')
    updateShowFoodForm(true)
  }

  const handleFoodFormClose = () => {
    updateShowFoodForm(false)
    if (foodKind !== 'current') {
      updateShowAddItemModal(true)
    }
  }

  const handleFoodFormSubmit = (item) => {
    let newFoods = foods.slice(0)
    if (foodKind === 'current') {
      newFoods.splice(editingItemIndex, 1, item)
    } else {
      newFoods.push(item)
    }
    updateFoods(newFoods)
    updateShowFoodForm(false)
    updateSearch('')
  }

  const handleQuickDelete = () => {
    if (foodKind === 'current') {
      let newFoods = foods.slice(0)
      newFoods.splice(editingItemIndex, 1)
      updateFoods(newFoods)
    }
    updateShowFoodForm(false)
  }

  const handleSaveTemplateMeal = () => {
    if (name === '') {
      updateNameError(true)
      openSnackbar('Please enter a name for this meal template.', true)
    } else {
      const lcName = name.toLowerCase()
      let duplicate = false
      for (let n = 0; n < meals.length; ++n) {
        if (meals[n].name.toLowerCase() === lcName) {
          if (mealIdStr === '0' || meals[n].id !== Number(mealIdStr)) {
            duplicate = true
          }
          break
        }
      }
      if (duplicate) {
        updateNameError(true)
        openSnackbar('A meal template with this name already exists.', true)
      } else {
        updateNameError(false)
        if (!saving) {
          updateSaving(true)
          if (mealIdStr === '0') {
            insertFavoriteMeal(user.id, name, foods, notes).then((res) => {
              updateSaving(false)
              window.localStorage.setItem('pendingSnackbar', 'The meal template was successfully added.')
              props.history.push('/dashboard/templates')
            })
          } else {
            updateFavoriteMeal(user.id, Number(mealIdStr), name, foods, notes).then((res) => {
              updateSaving(false)
              window.localStorage.setItem('pendingSnackbar', 'The meal template was successfully updated.')
              props.history.push('/dashboard/templates')
            })
          }
        }
      }
    }
  }

  const handleCancel = () => {
    props.history.push('/dashboard/templates')
  }

  const renderTotalMacros = () => {
    let totalProtein = 0
    let totalCarbs = 0
    let totalFat = 0
    let totalCalories = 0
    let totalFiber = 0;

    foods.forEach((foodItem) => {
      const item = new Item(foodItem)
      if (foodItem.itemType === 'recipe') {
        totalProtein += item.getRecipeProtein()
        totalCarbs += item.getRecipeCarbs()
        totalFat += item.getRecipeFat()
        totalFiber += item.getRecipeFiber()
      } else {
        totalProtein += item.getProtein()
        totalCarbs += item.getCarbs()
        totalFat += item.getFat()
        totalFiber += item.getFiber()
      }
    })

    totalCalories = (4 * (totalCarbs + totalProtein) + (9 * totalFat)).toFixed(0)
    totalProtein = totalProtein.toFixed(1)
    totalCarbs = totalCarbs.toFixed(1)
    totalFat = totalFat.toFixed(1)
    totalFiber = totalFiber.toFixed(1)

    return (
      <MacrosDisplay 
        protein={totalProtein}
        carbs={totalCarbs}
        fat={totalFat}
        calories={totalCalories}
        fiber={totalFiber}
      />
    )
  }

  return (
    <React.Fragment>
      <MealContainer>
        {mealStatus !== 2 ? (
          <CircularProgress size={32} />
        ) : (foods === null ? (
          <p>The meal with id {mealIdStr} was not found.</p>
        ) : (
          <>
            <PageTitle>{mealIdStr === '0' ? 'Add' : 'Edit'} Meal Template</PageTitle>
            <Input
              error={nameError}
              label="Name"
              value={name}
              onChange={updateName}
            />
            <Input
              label="Notes"
              value={notes}
              onChange={updateNotes}
            />
            {renderTotalMacros()}
            <div className="tracker-food-list">
              {foods.map((foodItem, itemIndex) => {
                const item = new Item(foodItem)
                let protein
                let carbs
                let fat
                if (foodItem.itemType === 'recipe') {
                  protein = item.getRecipeProtein()
                  carbs = item.getRecipeCarbs()
                  fat = item.getRecipeFat()
                } else {
                  protein = item.getProtein()
                  carbs = item.getCarbs()
                  fat = item.getFat()
                }
                return (
                  <div style={{position: 'relative'}} key={itemIndex}>
                    <button className="tracker-item-timeline" onClick={() => handleEditCurrent(itemIndex)}>
                      <img className="tracker-item-thumbnail" src={foodItem.thumbnailUrl ? foodItem.thumbnailUrl : GenericItem} alt="food-thumbnail" />
                      <div className="tracker-item-data">
                        <p className="name">{foodItem.name}</p>
                        <div className="macros-container">
                          <p className="unit">{foodItem.serving} {foodItem.unit}</p>
                          <div className="macros">
                            {foodItem.itemType !== 'alcohol' && <p className="macro">{protein.toFixed(1)} P</p>}
                            <p className="macro">{carbs.toFixed(1)} C</p>
                            <p className="macro">{fat.toFixed(1)} F</p>
                          </div>
                        </div>
                      </div>    
                    </button>
                  </div>
                )
              })}
            </div>
            <button
              className="tracker-add-item-button"
              onClick={handleAddFood}
            >
              <AddIcon />
              Add food
            </button>
            <ButtonContainer>
              <AddButton
                label="Save Meal Template"
                onClick={handleSaveTemplateMeal}
                isLoading={saving}
              />
              <AddButton
                label="Cancel"
                onClick={handleCancel}
              />
            </ButtonContainer>
            <AddItem
              search={search}
              updateSearch={updateSearch}
              open={showAddItemModal}
              onClose={() => updateShowAddItemModal(false)}
              proxyUserId={proxyUserId}
              itemType={itemType}
              updateItemType={updateItemType}
              handleAddItemPress={handleAddItemPress}
              handleAddCustomPress={handleAddCustomPress}
            />
            <FoodForm
              open={showFoodForm}
              onClose={handleFoodFormClose}
              handleFoodFormSubmit={handleFoodFormSubmit}
              handleQuickDelete={handleQuickDelete}
              foodLoading={foodLoading}
              foodItem={foodItem}
              updateFoodItem={updateFoodItem}
              itemType={itemType}
              foodKind={foodKind}
            />
          </>
        ))}
      </MealContainer>
    </React.Fragment>
  )
}

export default withRouter(MealEdit)